import { useParams } from "react-router";

import { AcquirerEditForm } from "src/app/features/Acquirer/components/forms/AcquirerEditForm";
import { ActionBar } from "../../../../components/ActionBar/ActionBar";
import { PageTitle } from "../../../../components/AppLayout/components/Content/components";
import { FPage, FPageContent, FPageHeader } from "../../../../components/AppLayout/components/FPageLayout";
import { CancelButton } from "../../../../components/FeatureButtons/CancelButton";
import { HistoryButton } from "../../../../components/FeatureButtons/HistoryButton";
import { OkButton } from "../../../../components/FeatureButtons/OkButton";
import { SubmitButton } from "../../../../components/FeatureButtons/SubmitButton";
import { useFormSubmitTrigger } from "../../../../components/Form/hooks/useFormSubmitTrigger";
import { getAssignedDataGroup } from "../../../../core/router/auth";
import { canAccess } from "../../../../core/router/auth/permissions";
import { ResourceName } from "../../../../core/router/config/ResourceName";
import { BASE_PATH, FORM_ACTION } from "../../../../core/router/types/routerTypes";

export const AcquirerEditFormPage = () => {
    const { runSubmit, formAction, triggerSubmit, triggerOk } = useFormSubmitTrigger();
    const hasWriteAccess = canAccess(ResourceName.ACQUIRER, "basicTabsWrite");
    const { id } = useParams();
    const dataGroup = getAssignedDataGroup();
    const historyUrl = `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/${ResourceName.ACQUIRER}/${id}/${FORM_ACTION.HISTORY}`;

    return (
        <FPage>
            <FPageHeader>
                <PageTitle translationKey="page.title.acquirersPhysicalEditFormPage" />
                <ActionBar>
                    <OkButton isDisabled={!hasWriteAccess} onClick={triggerOk} />
                    <SubmitButton isDisabled={!hasWriteAccess} onClick={triggerSubmit} />
                    <HistoryButton url={historyUrl} />
                    <CancelButton isDisabled={false} url={`${BASE_PATH}/${ResourceName.ACQUIRER}`} />
                </ActionBar>
            </FPageHeader>
            <FPageContent>
                <AcquirerEditForm runSubmit={runSubmit} formAction={formAction} />
            </FPageContent>
        </FPage>
    );
};
